"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PersonaHeaderShown: { datapoint: { name: 'PersonaHeaderShown' } },
};
//# sourceMappingURL=datapoints.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/people/owa-people-persona-header-view/lib/datapoints.js
// module id = 5974
// module chunks = 46